<!-- @format -->

<ng-container *transloco="let t">
  <sis-contextual-notification variant="danger" class="form-group">
    {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.EXPIRATION_IMMINENT_UNLESS", { expiryDate: attainment.expiryDate | localDateFormat }) }}
  </sis-contextual-notification>
</ng-container>
